import { AbstractControl, ValidatorFn } from '@angular/forms';
import {
  allowedLicensePlateSymbols,
  licensePlatePatterns,
} from '@sc/data-access-models';

export class LicensePlateNumberValidator {
  static pattern(patternLangs?: string[]): ValidatorFn {
    const fn = (control: AbstractControl): { [key: string]: boolean } => {
      const value: string = control?.value
        ?.replace(new RegExp(`[^${allowedLicensePlateSymbols}]`, 'g'), '')
        .toUpperCase();

      let patternsToCheck = [];

      if (patternLangs?.length > 0) {
        patternLangs.forEach((patternLang) => {
          if (licensePlatePatterns[patternLang]) {
            patternsToCheck = patternsToCheck.concat(
              licensePlatePatterns[patternLang]
            );
          }
        });
      }

      if (
        (!!value &&
          patternsToCheck.length &&
          !LicensePlateNumberValidator.checkValue(value, patternsToCheck)) ||
        (!value && !!control?.value)
      ) {
        return { license_plate_error: true };
      }

      return null;
    };

    return fn;
  }

  static checkValue(value: string, patternsToCheck: any[]): boolean {
    let valid = false;

    for (let i = 0; !valid && i < patternsToCheck.length; i++) {
      const pattern = patternsToCheck[i].pattern;
      if (new RegExp(pattern).test(value)) {
        valid = true;
      }
    }
    return valid;
  }
}
